import React from 'react'
import { useIntl } from 'react-intl'

type HomeHeroProps = {
  firstName: string | null
}

const HomeHero: React.FC<HomeHeroProps> = ({ firstName }) => {
  const intl = useIntl()
  const heading = firstName
    ? intl.formatMessage(
        { id: 'home.hero.headingWithName', defaultMessage: 'Welcome back, {firstName}.' },
        { firstName }
      )
    : intl.formatMessage({ id: 'home.hero.heading', defaultMessage: 'Welcome back.' })

  return (
    <section className="relative -mx-4 -mt-6 overflow-hidden bg-gray-200 px-6 py-16 sm:px-10 lg:mx-0">
      <img src="/images/header-hero.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" aria-hidden />
      <div className="absolute inset-0 bg-black/40" aria-hidden />
      <div className="relative max-w-2xl">
        <h1 className="text-3xl leading-tight font-semibold tracking-tight text-white sm:text-4xl">{heading}</h1>
        <p className="mt-3 text-sm font-medium text-white sm:text-base">
          {intl.formatMessage({
            id: 'home.hero.body',
            defaultMessage: "Here's everything we know right now.",
          })}
        </p>
      </div>
    </section>
  )
}

export default HomeHero
